import { useForm } from 'react-hook-form'

import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { GlobalAddress } from '@cash-web/protos/squareup/common/location.pb'
import { AddressBlocker } from '@cash-web/protos/squareup/franklin/blockers/address_blocker.pb'
import { AddressBlockerSupplement } from '@cash-web/protos/squareup/franklin/scenarios.pb'
import { AddressInput, AutocompleteAddressInput } from '@cash-web/shared-feature-form'

import { BaseBlocker, BlockerProps } from '../'
import { useAddress } from './useAddress'

interface Props extends BlockerProps {
  blocker: AddressBlocker
  supplement?: AddressBlockerSupplement
  buttons?: React.ReactNode[]
}

export function BlockerAddress({ blocker, skippable, buttons, supplement }: Props): React.ReactElement {
  const form = useForm<GlobalAddress>({ mode: 'onTouched' })
  const { canUseAutocompleteAddress, title, subtitle, onSubmit, countryCode, requiresState } = useAddress({ blocker })

  return (
    <BaseBlocker
      mainText={title}
      secondaryText={subtitle}
      form={form}
      onSubmit={onSubmit}
      skippable={skippable}
      buttons={buttons}
    >
      {countryCode ? (
        canUseAutocompleteAddress ? (
          <AutocompleteAddressInput
            autoFocus={true}
            countryCode={Country[countryCode]}
            prefill={{
              street: supplement?.address_prefill?.address_line_1,
              apartment: supplement?.address_prefill?.address_line_2,
              city: supplement?.address_prefill?.locality,
              state: supplement?.address_prefill?.administrative_district_level_1,
              postalCode: supplement?.address_prefill?.postal_code,
            }}
          />
        ) : (
          <AddressInput
            countryCode={Country[countryCode]}
            requiresStreetAddress={blocker.requires_street_address ?? false}
            requiresCity={blocker.requires_city ?? false}
            requiresState={requiresState}
            requiresPostalCode={blocker.requires_postal_code ?? false}
            autoFocus={true}
            prefill={{
              street: supplement?.address_prefill?.address_line_1,
              apartment: supplement?.address_prefill?.address_line_2,
              city: supplement?.address_prefill?.locality,
              state: supplement?.address_prefill?.administrative_district_level_1,
              postalCode: supplement?.address_prefill?.postal_code,
            }}
          />
        )
      ) : null}
    </BaseBlocker>
  )
}
